import { useState } from 'react'
import { Button, Popconfirm, Checkbox, message } from 'antd'
import { red } from '@ant-design/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faTrash } from '@fortawesome/pro-solid-svg-icons'

import API from '../../api'
import VSpace from '../../common/VSpace'

type Props = {
  type: string
  url: string
}

const DeleteAll = ({ type, url }: Props) => {
  const [retireTypes, setRetireTypes] = useState({
    labor: true,
    equipment: true,
    materials: true,
    subcontracting: true,
  })

  const prompt = type === 'items'
    ? <VSpace>
      <span>Are you sure you want to bulk retire items?</span>
      <Checkbox checked={retireTypes.labor} onChange={e => setRetireTypes({ ...retireTypes, labor: e.target.checked })}>Labor</Checkbox>
      <Checkbox checked={retireTypes.equipment} onChange={e => setRetireTypes({ ...retireTypes, equipment: e.target.checked })}>Equipment</Checkbox>
      <Checkbox checked={retireTypes.materials} onChange={e => setRetireTypes({ ...retireTypes, materials: e.target.checked })}>Materials</Checkbox>
      <Checkbox checked={retireTypes.subcontracting} onChange={e => setRetireTypes({ ...retireTypes, subcontracting: e.target.checked })}>Subcontracting</Checkbox>
    </VSpace>
    : <>Are you sure you want to delete all {type}?</>

  const deleteAll = async () => {
    try {
      if (type === 'items') {
        await API.delete(url, { params: retireTypes })
      } else {
        await API.delete(url)
      }
      message.success(type === 'items' ? 'Bulk retire successful.' : `All ${type} successfully deleted.`)
    } catch {
      message.error(`There was an error ${type === 'items' ? 'retiring' : 'deleting'} ${type}.`)
    }
  }

  const handlePopConfirm = async () => {
    await deleteAll()
  }

  return <>
    <Popconfirm placement="topLeft" title={prompt} onConfirm={handlePopConfirm} icon={<FontAwesomeIcon icon={faCircleInfo} style={{ color: red.primary }} />} okText="Yes" cancelText="No">
      <Button icon={<FontAwesomeIcon icon={faTrash} />} danger type="primary" size="large">{type === 'items' ? 'Bulk Retire By Category' : 'Delete All'}</Button>
    </Popconfirm>
  </>
}

export default DeleteAll
